// One delegated document-level listener for both [lt-submit-on-change] call sites
// (admin/shipping_labels/edit.html.haml, suppliers/shipping_labels/_created.html.haml), the same
// shape as single_action_guards.js.
//
// Scope is descendant <select>s of the element carrying the attribute, never the element itself -
// hence matching `event.target.closest("select")` inside an `[lt-submit-on-change]` ancestor, plus
// the `.contains` check so a later sibling doesn't claim it.
document.addEventListener("change", event => {
  const select = event.target.closest("select");
  if (!select) { return; }

  const container = select.closest("[lt-submit-on-change]");
  if (!container) { return; }

  container.querySelectorAll(".loader").forEach(loader => loader.classList.remove("hidden"));
  container.submit();
});
